export default {
    title: '正在拼命加载中,请耐心等待....',
}
